import { render } from "./Service2.vue?vue&type=template&id=c69f3eee"
import script from "./Service2.vue?vue&type=script&lang=js"
export * from "./Service2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__